
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accounts/login",
      function () {
        return require("private-next-pages/accounts/login/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accounts/login"])
      });
    }
  